import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private readonly _sidebarOpen = signal(false);
  private readonly _desktopSidebarCollapsed = signal(false);

  readonly sidebarOpen = this._sidebarOpen.asReadonly();
  readonly desktopSidebarCollapsed = this._desktopSidebarCollapsed.asReadonly();

  toggleSidebar(): void {
    this._sidebarOpen.update((v) => !v);
  }

  openSidebar(): void {
    this._sidebarOpen.set(true);
  }

  closeSidebar(): void {
    this._sidebarOpen.set(false);
  }

  toggleDesktopSidebar(): void {
    this._desktopSidebarCollapsed.update((value) => !value);
  }

  setDesktopSidebarCollapsed(collapsed: boolean): void {
    this._desktopSidebarCollapsed.set(collapsed);
  }
}
